import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// ══════════════════════════════════════════════════════════════════════
//  KUONDOA TOLEO LA ZAMANI LILILOHIFADHIWA (service worker)
//  Toleo la awali la App lilisajili "service worker" kwenye browser za
//  watu. Service worker huhifadhi App nzima na kuendelea kuionyesha hata
//  baada ya kudeploy toleo jipya — ndio maana mabadiliko yalionekana
//  kwenye kompyuta lakini si kwenye tovuti.
//
//  Code hii inaiondoa na kufuta akiba zote, kisha inaonyesha upya ukurasa
//  mara MOJA tu. Baada ya hapo kila deploy itaonekana mara moja.
// ══════════════════════════════════════════════════════════════════════
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(async (regs) => {
      if (!regs.length) return;
      await Promise.all(regs.map(r => r.unregister()));
      if (window.caches) {
        const keys = await caches.keys();
        await Promise.all(keys.map(k => caches.delete(k)));
      }
      // Onyesha upya mara moja tu ili toleo jipya lipakiwe
      if (!sessionStorage.getItem('sw-cleared')) {
        sessionStorage.setItem('sw-cleared', '1');
        window.location.reload();
      }
    })
    .catch(() => { /* si tatizo — App inaendelea kama kawaida */ });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);